import config from '@config';

import api from 'api';

/**
 * Fonctions de l'API REST WordPress
 */
export default {
	/**
	 * Retourne l'ensemble des pages du site
	 */
	getPages() {
		return new api.WPRequest(config.wp_api_path).get('pages').execute();
	},

	/**
	 * Retourne la page du site correspondant à un id précis
	 *
	 * @param {Number} id
	 */
	getPage(id) {
		return new api.WPRequest(config.wp_api_path)
			.get('pages/:id')
			.assert(id != null, new TypeError("L'id indiqué est nul"))
			.assert(!isNaN(id), new TypeError("L'id indiqué n'est pas un nombre valide"))
			.bind('id', id)
			.execute();
	},

	/**
	 * Retourne l'ensemble des catégories d'article du site
	 *
	 * @param {Boolean} showEmpty
	 *    Afficher également les catégories ne contenant aucun article
	 */
	getCategories(showEmpty = false, perPage = 100) {
		return new api.WPRequest(config.wp_api_path)
			.get('categories')
			.param('hide_empty', !showEmpty)
			.param('per_page', perPage)
			.execute();
	},

	/**
	 * Retourne la liste des articles du site
	 * @param {*} categories
	 *    si défini, filtrer les articles par catégories
	 *    Possibilité de filtrer plusieurs catégories en les séparant par une virgule dans un string ou en les donnant dans un tableau
	 *    ex : "10,12"  ou  [10, 12]
	 */
	getPosts(categories, per_page = undefined, page = undefined) {
		return new api.WPRequest(config.wp_api_path)
			.get('posts')
			.ifparam(categories !== undefined, 'categories', categories)
			.ifparam(per_page, 'per_page', per_page)
			.ifparam(page, 'page', page)
			.execute();
	},

	/**
	 * Retourne un article du site correspondant à un id précis
	 *
	 * @param {Number} id
	 */
	getPost(id) {
		return new api.WPRequest(config.wp_api_path)
			.get('posts/:id')
			.assert(id != null, new TypeError("L'id indiqué est nul"))
			.assert(!isNaN(id), new TypeError("L'id indiqué n'est pas un nombre valide"))
			.bind('id', id)
			.execute();
	},

	/**
	 * Retourne l'ensemble des entrées d'un post type donné
	 *
	 * @param {String} type
	 * @param {String} taxonomy
	 *    Un filtre par taxonomie à appliquer à la recherche
	 * @param {Number} taxonomyValue
	 *    La valeur de taxonomie à utiliser pour filtrer les résultats
	 */
	getAllOfType(type, taxonomy, taxonomyValue) {
		return new api.WPRequest(config.wp_api_path)
			.get(':type')
			.assert(type, new TypeError('Le type indiqué est nul'))
			.bind('type', type)
			.ifparam(
				taxonomy && taxonomyValue !== undefined && !isNaN(taxonomyValue),
				taxonomy,
				taxonomyValue
			)
			.execute();
	},

	/**
	 * Retourne l'ensemble des entrées d'un post type donné
	 *
	 * @param {String} type
	 * @param {Number} id
	 */
	getOfType(type, id) {
		return new api.WPRequest(config.wp_api_path)
			.get(':type/:id')
			.assert(type, new TypeError('Le type indiqué est nul'))
			.assert(id != null, new TypeError("L'id indiqué est nul"))
			.assert(!isNaN(id), new TypeError("L'id indiqué n'est pas un nombre valide"))
			.bind('type', type)
			.bind('id', id)
			.execute();
	},

	/**
	 * Retourne l'ensemble des taxonomies (existantes par défaut et créées)
	 */
	getTaxonomies() {
		return new api.WPRequest(config.wp_api_path).get('taxonomies').execute();
	},

	/**
	 * Retourne les valeurs possibles pour une taxonomie
	 *
	 * @param {String} taxonomy
	 */
	getTaxonomy(taxonomy) {
		return new api.WPRequest(config.wp_api_path)
			.get(':taxonomy')
			.assert(taxonomy, new TypeError('Le nom de taxonomy indiqué est nul'))
			.bind('taxonomy', taxonomy)
			.execute();
	},

	/**
	 * Retourne un media du site correspondant à un id précis
	 *
	 * @param {Number} id
	 */
	getMedia(id) {
		return new api.WPRequest(config.wp_api_path)
			.get('media/:id')
			.assert(id != null, new TypeError("L'id indiqué est nul"))
			.assert(!isNaN(id), new TypeError("L'id indiqué n'est pas un nombre valide"))
			.bind('id', id)
			.execute();
	},
};



// WEBPACK FOOTER //
// ./src/api/wordpress.js